var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_187560",
    "data-name": "Group 187560",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.282,
    height: 27.282,
    viewBox: "0 0 27.282 27.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187584",
    "data-name": "Group 187584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185646",
    "data-name": "Group 185646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187479",
    "data-name": "Group 187479"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147040",
    "data-name": "Rectangle 147040",
    width: 27.282,
    height: 27.282,
    rx: 4,
    fill: "#fbf2ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-calendar",
    "data-name": "Icon feather-calendar",
    transform: "translate(7.89 7.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M5.778,6h8.946A1.278,1.278,0,0,1,16,7.278v8.946A1.278,1.278,0,0,1,14.724,17.5H5.778A1.278,1.278,0,0,1,4.5,16.224V7.278A1.278,1.278,0,0,1,5.778,6Z",
    transform: "translate(-4.5 -4.722)",
    fill: "none",
    stroke: "#61277f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M24,3V5.556",
    transform: "translate(-15.693 -3)",
    fill: "none",
    stroke: "#61277f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M12,3V5.556",
    transform: "translate(-8.805 -3)",
    fill: "none",
    stroke: "#61277f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M4.5,15H16",
    transform: "translate(-4.5 -9.888)",
    fill: "none",
    stroke: "#61277f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fec2079628cf26249804d346f89b0032.svg";
export { ForwardRef as ReactComponent };